import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkHasUnsavedChanges, confirmUnsavedChanges } from "utility/utility";
import { Tooltip } from "@material-ui/core";
import BreadCrumb from "components/shared/Navigation/BreadCrumb";
import { FLIGHTING_CONSTANTS, ENTITY_TYPES } from "utility/constants/constants";
import { EntityMenu } from "components/shared/EntityMenu/EntityMenu";
import { EntityModals } from "components/shared/EntityModals/EntityModals";
import swal from "sweetalert";
import * as commonService from "utility/CommonService";
import * as projectsActions from "redux/actions/ProjectsActions";
import { updateProject } from "redux/actions/ProjectsActions";

const Header = ({
  setShowPublishModal,
  setShowCreateWorkflowModal,
  accessLevel,
  repoContentsLoaded
}) => {
  const dispatch = useDispatch();
  const { project, projectFilesContent } = useSelector(
    (state) => state.projectsReducer
  );
  const history = useHistory();
  const prevLocation = history.location.state?.prevLocation;

  const [showEditModal, setShowEditModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  const handleDelete = () => {
    swal({
      text: "Are you sure you want remove this from the projects page?",
      className: "logout-alert-modal",
      buttons: [true, "Delete"],
    }).then((result) => {
      if (result) {
        dispatch(projectsActions.deleteProject({ id: project.id })).then((res) => {
          if (res.value && res.value.success) {
            commonService.forSuccess("Project Deleted!", "Success");
            history.push("/projectsv2");
          }
        });
      }
    });
  };

  const handleGoBack = () => {
    if (checkHasUnsavedChanges(projectFilesContent)) {
      confirmUnsavedChanges().then((res) => {
        if (res)
          return history.length > 2 ? history.goBack() : history.push("/projectsv2")
      })
    } else {
      return history.length > 2 ? history.goBack() : history.push("/projectsv2")
    }
  };

  return (
    project && <div className="projects_header">
      <BreadCrumb
        currentLoc={project.name}
        previousLoc={`${prevLocation || FLIGHTING_CONSTANTS.PROJECTS} List`}
        goBack={handleGoBack}
      />
      <div className="projects_header_right">
        <EntityMenu
          onEdit={() => setShowEditModal(true)}
          onShare={() => setShowShareModal(true)}
          onDelete={handleDelete}
          tooltipTitle={["view"].includes(accessLevel) ? "You need execute or edit access" : "More"}
        />
        <Tooltip title={(!repoContentsLoaded || ["view"].includes(accessLevel)) ? "You need execute or edit access" : ""}>
          <span>
            <button
              className="btn_small"
              onClick={() => setShowCreateWorkflowModal(true)}
              disabled={!repoContentsLoaded || ["view"].includes(accessLevel)}
            >
              Initialize Workflow
            </button>
          </span>
        </Tooltip>
        <Tooltip title={(!repoContentsLoaded || ["view"].includes(accessLevel)) ? "You need execute or edit access" : ""}>
          <span>
            <button
              className="btn_small"
              onClick={() => setShowPublishModal(true)}
              disabled={!repoContentsLoaded || ["view"].includes(accessLevel)}
            >
              publish
            </button>
          </span>
        </Tooltip>
      </div>
      <EntityModals
        entity={project}
        entityType={ENTITY_TYPES.PROJECT_V2}
        updateEntity={updateProject}
        showEditModal={showEditModal}
        setShowEditModal={setShowEditModal}
        showShareModal={showShareModal}
        setShowShareModal={setShowShareModal}
      />
    </div>
  );
};

export default Header;
